import apiClient from './apiClient'
import type { GetNotesResponse, SyncNotesRequest, SyncNotesResponse } from '@/types/api'

/**
 * GET /api/notes
 * Get all notes for the current user.
 */
export async function fetchNotes(): Promise<GetNotesResponse> {
  const { data } = await apiClient.get<GetNotesResponse>('/notes')
  return data
}

/**
 * POST /api/notes/sync
 * Batch sync notes (create, update, delete) with offline support.
 */
export async function syncNotes(
  request: SyncNotesRequest
): Promise<SyncNotesResponse> {
  const { data } = await apiClient.post<SyncNotesResponse>('/notes/sync', request)
  return data
}
